import { BasicInput } from '@carrot/style-components/input/basic';

export const Input = Object.assign(BasicInput, {});
